import { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BaseEdge, useStore, EdgeProps, NodeProps } from "reactflow";
import { DEFAULT_LINE_STYLE, NEW_EDGE_REG, ERROR_LINE_STYLE } from "../../../views/thinking-layout-editor/constants";
import { getSmoothStepPath, getPath } from "../../../uikit/util/getSmoothStepPath";
import { CustomNewLineBloc } from "./CustomNewLineBloc";
import { fotActions } from "../../../store/fot";
import { useHomeChildContainer } from "../../../custom-hooks/HomeUsePluginRoot/childContainer";
import func from "@uikit/func";
import pathStyle from "./CustomNewLine.module.scss";

export default function CustomNewLine({
  id,
  source,
  target,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = DEFAULT_LINE_STYLE,
  markerEnd,
  data,
}: EdgeProps) {
  const dispatch = useDispatch();
  const { setEdges, getHomeNodes, getHomeEdges } = useHomeChildContainer();
  const sourceNode = useStore(useCallback(store => store.nodeInternals.get(source), [source])) as any;
  const targetNode = useStore(useCallback(store => store.nodeInternals.get(target), [target])) as any;

  let firstSourceNodeId = targetNode.data?.flows?.[0]?.sourceNodeId || source;
  if (func.isEmpty(targetNode.data?.flows?.[0]?.sourceNodeId) && NEW_EDGE_REG.test(source)) {
    const sourceLines = getHomeEdges().filter((x: any) => x.target === source);
    firstSourceNodeId = func.isEmpty(sourceLines) ? firstSourceNodeId : sourceLines[0]?.source;
  }

  const edgeNode = NEW_EDGE_REG.test(targetNode.id) ? targetNode : sourceNode;

  const realTargetNodeId = edgeNode.data?.targetNodeId;
  const firstSourceNode = useStore(
    useCallback(store => store.nodeInternals.get(firstSourceNodeId), [firstSourceNodeId])
  ) as any;
  const realTargetNode = useStore(
    useCallback(store => store.nodeInternals.get(realTargetNodeId), [realTargetNodeId])
  ) as any;

  const bloc = new CustomNewLineBloc({
    id,
    sourceNode,
    targetNode,
    firstSourceNode,
    realTargetNode,
    getHomeNodes,
    setEdges,
  });
  const edgePath = bloc.getPath();

  useEffect(() => {
    bloc.handleHoverEdgeDataEffect();
  }, [
    bloc.hoverEdgeData.value.state,
    bloc.hoverEdgeData.value.edgeId,
    bloc.hoverEdgeData.value.isSelected,
    bloc.hoverEdgeData.value.lineIds,
  ]);

  useEffect(() => {
    bloc.handleCheckEdgeArrEffect();
  }, [bloc.checkEdgeArr.length]);

  const isIncludesId = bloc.checkEdgeArr.includes(id);
  const needHighlight = bloc.needHighlight.value;

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      {(isIncludesId || needHighlight) && style.stroke !== ERROR_LINE_STYLE.stroke ? (
        <path
          fill="none"
          d={edgePath}
          stroke={data.stateConfig.color}
          strokeWidth={10}
          strokeOpacity={0.25}
          strokeLinecap="round"
          className={`${needHighlight && !isIncludesId ? pathStyle["select-border_animated"] : ""}`}
        />
      ) : null}
    </>
  );
}
